export enum ReservationType {
    SelfReservation = 'SELF_RESERVATION',
    ThirdPartReservation = 'THIRD_PART_RESERVATION',
}
